// Module
var code = `<amt-chart ng-if="sense_evetns_loaded" name="admin_events.IncomeEventsChart" cdata="sense_evetns_chart_data">

</amt-chart>
<table class="table">
	<tr>
		<th>Service</th>
		<th>Name</th>
		<th>Table</th>
		<th>Sample key</th>
		<th>Size</th>
		<th>Actions</th>
	</tr>
	<tr>
		<td>-</td>
		<td>-</td>
		<td>All</td>
		<td>-</td>
		<td>{{total_tables_size | filesize}} / {{db_size | filesize:1}}</td>
		<td>-</td>
	</tr>
	<tr ng-repeat="event in events">
		<td>{{event.service}}</td>
		<td>{{event.name}}</td>
		<td>{{event.table}}</td>
		<td>{{event.sample_key}}</td>
		<td>{{tables_size[event.table] || 0 | filesize:1}}</td>
		<td>
			<button class="btn btn-info btn-xs"
					ui-sref="amt.ww2.event_stats({event_table:event.table})">Stats</button>
			<button class="btn btn-info btn-xs"
					ui-sref="amt.ww2.event_schema({event_table:event.table})">Schema</button>
			<button class="btn btn-info btn-xs"
					ui-sref="amt.ww2.event_partitions({event_table:event.table})">Partitions</button>
		</td>
	</tr>
</table>
`;
// Exports
module.exports = code;